
export const LOG_IN_REQUEST = 'logInRequest';
export function logInRequest(username, password) {
    return {
        type: LOG_IN_REQUEST,
        username,
        password
    };
}
export const LOG_IN_SUCCESS = 'logInSuccess';

/**
 * user {
 *     username,
 *     password
 * }
 * @param user
 * @returns {{type: string, user: *}}
 */
export function logInSuccess(user) {
    return {
        type : LOG_IN_SUCCESS,
        user
    }
}
export const LOG_IN_FAILURE = 'logInFailure';
export function logInFailure() {
    return {
        type: LOG_IN_FAILURE
    }
}

export const LOG_OUT = "logOut";
export function logOut() {
    return {
        type: LOG_OUT
    };
}



// WEBPACK FOOTER //
// ./src/actions.js